import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        sugarChallengeQuestions: 5,
        diabetesChallengeQuestions: 10,
    },
    mutations: {
        setConfig(state, config) {
            state.sugarChallengeQuestions = config.sugarChallengeQuestions;
            state.diabetesChallengeQuestions = config.diabetesChallengeQuestions;
        },
    },
    getters: {
        getGameQuestionAmount(state, getters, rootState, rootGetters) {
            return (game) => {
                const config = rootGetters.isInEvent ? {
                    game1: rootState.user.event.tfQuestions,
                    game2: rootState.user.event.choiceQuestions,
                    test: 1,
                } : {
                    game1: state.sugarChallengeQuestions,
                    game2: state.diabetesChallengeQuestions,
                };
                return config[game];
            };
        },
        getLevelScore() { // 沒有跟 GameConfig 同步，記得同步修改
            return (level) => ({
                1: 3,
                2: 5,
                3: 10,
            }[level]);
        },
        getGameDuration() { // 沒有跟 GameConfig 同步，記得同步修改
            return (game, level) => ({
                game1: { 1: 120, 2: 140, 3: 180 },
                game2: { 1: 160, 2: 190, 3: 240 },
            }[game][level]);
        },
        getTrophyThreshold(state, getters) {
            return (game, level) => {
                const questionCount = getters.getGameQuestionAmount(game);
                const scorePerQuestion = getters.getLevelScore(level);
                const gameDuration = getters.getGameDuration(game, level);
                const value = (questionCount * scorePerQuestion + (gameDuration) / 3) / 8;
                return Math.round(value);
            };
        },
    },
    actions: {
        async fetchConfig({ commit }) {
            const config = await Sdk.fetchConfig();
            commit('setConfig', config);
        },
    },
};
